const shouldUseAhuPath = pathname => {
    return pathname == "/" || pathname.startsWith("/ahu");
};

export const getLocationPath = pathname => {
    return shouldUseAhuPath(pathname) ? "/ahu" : process.env.SDS_APP_PREFIX;
};

export default getLocationPath;
